import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { Card, CardBody } from '../../../../../components/card'
import Checklist from '../../../../../components/checklist'

import styles from './feature-grid-card.module.scss'

const FeatureGridCard = () => {
  const summaryFeatures = [
    <FormattedMessage
      defaultMessage="Lönespecifikationer byggs automatiskt i realtid"
      id="diy-payroll.sub-features.1"
      key="1"
    />,
    <FormattedMessage
      defaultMessage="Skapa standardlöner och slipp fylla i varje månad"
      id="diy-payroll.sub-features.2"
      key="2"
    />,
    <FormattedMessage defaultMessage="Lägg enkelt till förmåner och avdrag" id="diy-payroll.sub-features.3" key="3" />,
    <FormattedMessage
      defaultMessage="Dina anställa fotar enkelt kvitton i appen"
      id="diy-payroll.sub-features.4"
      key="4"
    />,
    <FormattedMessage defaultMessage="Godkänn utlägg på några sekunder" id="diy-payroll.sub-features.5" key="5" />,
    <FormattedMessage defaultMessage="Full integration med Dooer bokföring" id="diy-payroll.sub-features.6" key="6" />,
    <FormattedMessage
      defaultMessage="AGI-rapporter till skatteverket med ett klick"
      id="diy-payroll.sub-features.7"
      key="7"
    />,
    <FormattedMessage defaultMessage="Betala ut löner direkt från Dooer" id="diy-payroll.sub-features.8" key="8" />,

    <FormattedMessage defaultMessage="Olika löneperioder" id="diy-payroll.sub-features.9" key="9" />,
    <FormattedMessage defaultMessage="Obegränsat antal anställda" id="diy-payroll.sub-features.10" key="10" />,
    <FormattedMessage defaultMessage="Olika anställningsformer" id="diy-payroll.sub-features.11" key="11" />,
    <FormattedMessage defaultMessage="Koppla företagskort" id="diy-payroll.sub-features.12" key="12" />,
    <FormattedMessage defaultMessage="Lönekörning" id="diy-payroll.sub-features.13" key="13" />,
    <FormattedMessage defaultMessage="Semesterhantering" id="diy-payroll.sub-features.14" key="14" />,
    <FormattedMessage defaultMessage="och mycket mer!" id="diy-payroll.sub-features.15" key="15" />,
  ]

  return (
    <Card className={styles.root}>
      <CardBody>
        <FormattedHTMLMessage
          defaultMessage="Smarta funktioner du kommer älska"
          id="diy-payroll.sub-features.title"
          tagName="h2"
        />
        <FormattedHTMLMessage
          defaultMessage="Ett komplett löneprogram anpassat för dig"
          id="diy-payroll.sub-features.lede"
          tagName="p"
        />
        <div className={styles.seperator} />
        <Checklist col={3} horizontal items={summaryFeatures} lastIsSeeMore />
      </CardBody>
    </Card>
  )
}

export default FeatureGridCard
